(() => {
  let expiryTimer;
  const campaignEnd = Date.parse('2026-12-01T00:00:00+03:00');
  const expireCampaignElements = () => {
    window.clearTimeout(expiryTimer);
    const now = Date.now();
    let nextExpiry = Infinity;
    let expired = false;
    document.querySelectorAll('[data-bs-campaign][data-bs-campaign-end]').forEach((element) => {
      const end = Date.parse(element.dataset.bsCampaignEnd);
      if (!Number.isFinite(end)) return;
      if (now >= end) {
        element.hidden = true;
        expired = true;
      } else {
        nextExpiry = Math.min(nextExpiry, end);
      }
    });
    if (now >= campaignEnd) {
      document.querySelectorAll('[data-bs-campaign-message]').forEach((element) => {
        element.hidden = true;
      });
      document.querySelectorAll('[data-bs-campaign-fallback]').forEach((element) => {
        element.hidden = false;
      });
      document.querySelectorAll('[data-bs-november-hero]').forEach((element) => {
        element.classList.remove('bs-november');
        const title = element.querySelector('[data-bs-campaign-fallback] h1');
        if (title?.id) element.setAttribute('aria-labelledby', title.id);
      });
      expired = true;
    } else if (document.querySelector('[data-bs-campaign-message]')) {
      nextExpiry = Math.min(nextExpiry, campaignEnd);
    }
    if (expired) document.dispatchEvent(new CustomEvent('beskar:campaign-ended'));
    if (Number.isFinite(nextExpiry)) {
      expiryTimer = window.setTimeout(expireCampaignElements, Math.min(nextExpiry - now + 50, 2147483647));
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', expireCampaignElements, { once: true });
  } else {
    expireCampaignElements();
  }
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) expireCampaignElements();
  });
  document.addEventListener('shopify:section:load', expireCampaignElements);
})();

